import { useContext, useEffect } from 'react';

import { NotificationContext } from '../../contextStore/NotificationContext';
import { AppContext } from '../../contextStore/AppContext';

export const useLanguageDropdownController = () => {
  const { setData } = useContext(AppContext);
  const { closeNotification } = useContext(NotificationContext);

  useEffect(() => {
    closeNotification();

    setData({ isLanguageDropdownDisabled: true });

    return () => {
      setData({ isLanguageDropdownDisabled: false });
    };
  }, []);
};
